var EventController = /** @class */function () {
  function EventController(graph) {
    this.graph = graph;
    this.destroyed = false;
    this.initEvents();
  }
  return EventController;
}();
export default EventController;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-core/es/graph/controller/event.js
// module id = null
// module chunks = 